import React from "react";

import { Chip } from "@mui/material";

import { Check } from "../../../components/icons/Check";
import { Access } from "../../../consts/access";
import { CafsType } from "../../../consts/cafsType";
import { FarmTreeRoles } from "../../../consts/farm-tree-roles";
import { UserRole } from "../../../consts/user-role";
import { useAuth } from "../../../hooks/useAuth";
import { CafsTreeNodeType } from "../../../types/cafs-tree-node-type";

import { ActionIcons } from "./ActionIcons";
import { LabelIcon } from "./LabelIcon";

export type TreeItemLabelProps = {
  node: CafsTreeNodeType;
  isSelected: boolean;
  allCafsNodes: CafsTreeNodeType[];
};

export function CafsTreeItemLabel({
  isSelected,
  node,
  allCafsNodes,
}: TreeItemLabelProps) {
  const { user } = useAuth();
  const canSeeConfidential =
    user?.Role &&
    (FarmTreeRoles.includes(user.Role as UserRole) ||
      user.Role === UserRole.ProjectOwner);

  const shouldShowConfidentialSuffix =
    canSeeConfidential &&
    node.type === CafsType.Input &&
    node.confidentialSuffix != null &&
    node.confidentialSuffix !== "";

  const shouldShowConfidentialSpec =
    canSeeConfidential &&
    (node.type === CafsType.Tree || node.type === CafsType.Crop) &&
    node.confidentialSpec != null &&
    node.confidentialSpec !== "";

  return (
    <div className="flex flex-row">
      <div className="w-full flex flex-row justify-between items-center">
        <div className="flex flex-row items-center">
          <div className="flex flex-row justify-end items-center pr-1 w-auto">
            <LabelIcon node={node} isSelected={isSelected} />
          </div>
          <div
            className={`text-shark ${node.access === Access.None ? "text-darkGray" : ""}`}>
            {node.isAssigned ? (
              <div className="flex flex-row items-center gap-2">
                {node.name || ""}
                {shouldShowConfidentialSuffix && (
                  <Chip
                    label={node.confidentialSuffix}
                    size="small"
                    sx={{ height: "20px", fontSize: "0.75rem" }}
                  />
                )}
                {shouldShowConfidentialSpec && (
                  <Chip
                    label={node.confidentialSpec}
                    size="small"
                    sx={{ height: "20px", fontSize: "0.75rem" }}
                  />
                )}
                <Check className="text-green text-xl ml-2" />
              </div>
            ) : (
              <div className="flex flex-row items-center gap-2">
                <span>{node.name || ""}</span>
                {shouldShowConfidentialSuffix && (
                  <Chip
                    label={node.confidentialSuffix}
                    size="small"
                    sx={{ height: "20px", fontSize: "0.75rem" }}
                  />
                )}
                {shouldShowConfidentialSpec && (
                  <Chip
                    label={node.confidentialSpec}
                    size="small"
                    sx={{ height: "20px", fontSize: "0.75rem" }}
                  />
                )}
              </div>
            )}
          </div>
        </div>
        <ActionIcons node={node} allCafsNodes={allCafsNodes} />
      </div>
    </div>
  );
}
